import { render, staticRenderFns } from "./DetalhesCliente.vue?vue&type=template&id=ff6007d0"
import script from "./DetalhesCliente.vue?vue&type=script&lang=js"
export * from "./DetalhesCliente.vue?vue&type=script&lang=js"
import style0 from "./DetalhesCliente.vue?vue&type=style&index=0&id=ff6007d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports